import React, {useState} from 'react';
import styles from '../GeneratePersonalDocsModal/GeneratePersonalDocsModal.module.css';
import Button from '../../Button/Button';
import PickTemplates, {buildPlaceholdersForTemplate} from '../../DocumentTabs/components/PickTemplates/PickTemplates';
import useApi from '../../../hooks/useApi.hook';
import Spinner from '../../Spinner/Spinner';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import {apiErrorMessage} from '../../../helpers/apiError';
import {notifyDownloadQueued} from '../../../helpers/downloadsEvents';
import {getAllDocumentsUrl} from '../../../helpers/constants';

// Organization templates have no fields of their own, so one set of placeholders serves the whole batch.
const BATCH_PLACEHOLDERS = {input_placeholders: [{key: '{{дата документа}}'}]};

export function GenerateOrgDocsModal({
	templateCodes,
	onSuccess,
	onLoadingChange
}) {
	const api = useApi();
	const [placeholders, setPlaceholders] = useState(
		() => buildPlaceholdersForTemplate(BATCH_PLACEHOLDERS)
	);
	const [error, setError] = useState(undefined);
	const [loading, setLoading] = useState(false);

	const setGenerating = (value) => {
		setLoading(value);
		onLoadingChange?.(value);
	};

	const handleGenerate = async () => {
		const plh = placeholders
			.filter((p) => p.key?.trim() && p.value?.trim())
			.map((p) => ({ key: p.key, value: p.value }));

		if (templateCodes.length === 0) return;
		setError(undefined);
		setGenerating(true);
		try {
			const response = await api.post(`${getAllDocumentsUrl}/organization_generate_zip`, {
				templates: templateCodes,
				placeholders: plh
			});
			notifyDownloadQueued(response.data);
			onSuccess();
		} catch (e) {
			setError(apiErrorMessage(e));
		} finally {
			setGenerating(false);
		}
	};

	return (
		<div className={styles.container}>
			<h2 className={styles.title}>Сформировать документы организации</h2>
			<p className={styles.subtitle}>
				Выбрано документов: {templateCodes.length}. Дата документа станет датой оформления в контроле сроков.
			</p>
			<ErrorMessage
				error={error}
				onClose={() => setError(undefined)}
			/>
			<PickTemplates
				groupName="organization"
				selectedTemplate={templateCodes[0]}
				setSelectedTemplate={() => {}}
				placeholders={placeholders}
				setPlaceholders={setPlaceholders}
				hideSelect
			/>
			<div className={styles.button}>
				<Button onClick={handleGenerate} disabled={loading}>
					Сформировать
				</Button>
			</div>
			{loading && (
				<div className={styles.spinnerOverlay}>
					<Spinner showSeconds={true} />
				</div>
			)}
		</div>
	);
}
